<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText2: '',
    };
  },
  mounted () {
    this.richText2 = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Biomarker and Drug R&D Platform</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:75%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">The platform currently has more than 80 instruments including Elemental Analyzer(EA), Ion Chromatography System (ICS), Inductively Coupled Plasma Optical Emission Spectrometry System (ICP-OES), Inductively Coupled Plasma Mass Spectrometer（ICP-MS）, Infrared Spectrometer (IR), Raman Microscope, Nuclear Magnetic'
      + 'Resonance Spectrometer (NMR), Liquid Chromatograph-Mass Spectrometer (LC-MS),Gas Chromatography-Mass Spectrometer (GC-MS), Single-Crystal X-Ray Diffractometer (XRD), Thermal Gravimetric Analyzer (TGA), Reaction Calorimetry Workstation,Automatic Parallel Reactor, In situ Infrared-Based Reaction Monitoring System, Focused Beam Reflectance Measurement (FBRM) Analyzer, Particle Video Microscope,'
      + 'etc. We can provide services for clinical omics research, pharmaceutical analysis, pharmaceutical quality control, product isolation and purification, and chemical process safety assessment.</span></p>'
      + '</div>'

      + '<div id="right" style="float:left ; width:25%; height:100%;">'
      + '<p style="margin-left : 40px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/lizhang.jpg" style="float: left; width: 200px; margin-right: 30px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left:50px;text-align: justify"><span style="font-size: 16px;"><b>Director: Li Zhang</b></span></p>'
      + '</div>'
      + '<p>&nbsp;</p>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;The clinical Omics Analysis System&nbsp;&nbsp;&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：High-throughput Genome Sequencing System, Chromatography-Mass Spectrometry System, NMR, ICP-MS, etc.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services：proteomics, untargeted/targeted metabolomics, lipidomics, genome sequencing technologies.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;Biopharmaceuticals Analysis System &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：LC-HRMS, Protein Interaction Analyzer, Microplate Reader, NMR, etc.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: structural characterization, impurity analysis, bioactivity evaluation.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Pharmaceutical Quality Control Analysis System </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：Spectrometers, NMR, Chromatography-Mass Spectrometry System, EA, ICP-MS, XRD, Electron Microscope, TGA, DSC, etc.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: pharmaceutical structure confirmation，impurity analysis, pharmaceutical quality control，and pharmaceutical excipients and packaging materials analysis,etc.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> Process Safety Assessment and Isolation/Purification System</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment：Automatic Parallel Reactor, Accelerating Rate Calorimeter, Particle Video \n' +
      'Microscope, Preparative Chromatography System, etc.</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services: chemical process safety assessment, in situ monitoring of pharmaceutical crystallization, compound</span></p>'

      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/biomarker_Drug_en_1.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Li Zhang</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: lizhang09@sjtu.edu.cn</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Tel: +86-021 - 34208498 - 6421</span></p>'

      + '</div>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service12/en/index.vue